import { Component, OnInit } from '@angular/core';
import { StateService } from "@uirouter/core";
import { UntilDestroyedMixin } from "core-app/helpers/angular/until-destroyed.mixin";
import { PathHelperService } from "core-app/modules/common/path-helper/path-helper.service";
import { IOPFormlyFieldSettings } from "core-app/modules/common/dynamic-forms/typings";
import { CurrentProjectService } from "core-components/projects/current-project.service";

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent extends UntilDestroyedMixin implements OnInit {
  projectsPath:string;
  formMethod = 'patch';
  text:{ [key:string]:string };
  dynamicFieldsSettingsPipe:(dynamicFieldsSettings:IOPFormlyFieldSettings[]) => IOPFormlyFieldSettings[];
  hiddenFields = ['identifier', 'active'];

  constructor(
    private _pathHelperService:PathHelperService,
    private _$state:StateService,
    private _currentProjectService:CurrentProjectService,
  ) {
    super();
  }

  ngOnInit():void {
    this.projectsPath = this._currentProjectService.apiv3Path!;
    this.dynamicFieldsSettingsPipe = (dynamicFieldsSettings) => {
      return dynamicFieldsSettings
        .reduce((formattedDynamicFieldsSettings:IOPFormlyFieldSettings[], dynamicFormField) => {
          if (this.isFieldHidden(dynamicFormField.key)) {
            dynamicFormField = {
              ...dynamicFormField,
              hide: true,
            }
          }

          return [...formattedDynamicFieldsSettings, dynamicFormField];
        }, []);
    }
  }

  private isFieldHidden(name:string|undefined) {
    return this.hiddenFields.includes(name || '');
  }
}
